import initRedacted from "./ui/redacted.js";
import initTabs from "./ui/tabs.js";
import initMap from "./map/map.js";

document.addEventListener("DOMContentLoaded", () => {
    initRedacted();
    initTabs();
    initMap();
});
